const images = {
  LocationImage: require("./location.webp"),
  PathogenRisk: require("./pathogen-risk.webp"),
  PathogenClock: require("./pathogen-clock.webp"),
  DownyMildew: require("./downy-mildew.webp"),
  PathogenElevated: require("./pathogen-elevated.webp"),
  PowderyMildew: require("./powdery-mildew.webp"),
  RiskTrend: require("./risk-trend.webp"),
};

export default images;
